import React, { useEffect, useMemo } from 'react';
import KSCheckBox from '../../../KSCheckBox';
import { useFormContext } from 'react-hook-form';

interface ShowBudgetProps {
  isAggrSideBySide: boolean;
  hasBudgets?: boolean;
}

function ShowBudget({ isAggrSideBySide, hasBudgets = false }: ShowBudgetProps) {
  const { watch, reset } = useFormContext();

  const selectedTimeframe = watch('timeframe');

  useEffect(() => {
    const currentBudgetInclude = watch('budgets.include');
    if (!hasBudgets) {
      if (currentBudgetInclude) {
        reset({
          ...watch(),
          budgets: {
            include: false,
          },
        });
      }

      return;
    }

    if (!currentBudgetInclude) {
      reset({
        ...watch(),
        budgets: {
          include: true,
        },
      });
    }
  }, [hasBudgets, watch, reset]);

  const shouldDisabledBudgetInclude = useMemo(() => {
    if (isAggrSideBySide) {
      return true;
    }
    if (watch('total')) {
      return true;
    }

    return !hasBudgets;
  }, [selectedTimeframe, watch('total'), isAggrSideBySide, hasBudgets]);

  return (
    <KSCheckBox
      disabled={shouldDisabledBudgetInclude}
      label="Show Budget"
      checked={watch('budgets.include')}
      tooltip={
        !hasBudgets
          ? 'No Budgets are available for the selected timeframe, please contact KitchenSync for help in setting budgets'
          : undefined
      }
      showTooltipIcon={!hasBudgets}
      onChange={() => {
        reset({
          ...watch(),
          budgets: {
            include: !watch('budgets.include'),
          },
          difference: false,
        });
      }}
    />
  );
}

export default ShowBudget;
